import React, { ReactNode } from 'react';
import classNames from 'classnames';
import styles from './UserManagementDrawerLayout.module.scss';

export type UserManagementDrawerLayoutProps = {
    sidebar: ReactNode;
    main: ReactNode;
    className?: string;
    /** `stacked`: user details (sidebar) first, then main (e.g. site permissions) full width below */
    variant?: 'twoColumn' | 'stacked';
};

/**
 * Shared shell for user create / edit / view drawers. No Redux — compose from parent flows.
 */
const UserManagementDrawerLayout = ({ sidebar, main, className, variant = 'twoColumn' }: UserManagementDrawerLayoutProps) => {
    const isStacked = variant === 'stacked';
    return (
        <div className={classNames(isStacked ? styles.rootStacked : styles.root, className)}>
            <div className={styles.sidebar}>{sidebar}</div>
            {main !== null ? <div className={styles.main}>{main}</div> : null}
        </div>
    );
};

export default UserManagementDrawerLayout;
